import { render } from "./ViewContratPage.vue?vue&type=template&id=613972ee&ts=true"
import script from "./ViewContratPage.vue?vue&type=script&lang=ts"
export * from "./ViewContratPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__